
import { Component, Prop, Vue } from 'vue-property-decorator';
import DefaultColors from '../../constants/Whitelabel/DefaultThemeVariables';
import icons from './icons';

@Component({
  components: { ...icons },
})
export default class MomntIcon extends Vue {
  @Prop({ default: 24, type: [Number, String] }) readonly size! : number | string;

  @Prop({ default: DefaultColors.grayscaleColor1, type: String }) readonly color! : string;

  /**
   * Transforms snake_case string to camelCase component name
   */
  get iconComponent(): string {
    return (this.$slots.default?.[0].text || '')?.toLowerCase()
      .replace(/(_[a-z])/g, (group) => group.toUpperCase().replace('_', ''));
  }

  get style() {
    return {
      color: this.color,
    };
  }
}
